import { render, staticRenderFns } from "./IconCheckGray.vue?vue&type=template&id=5d4b07ab&scoped=true&"
import script from "./IconCheckGray.vue?vue&type=script&lang=ts&"
export * from "./IconCheckGray.vue?vue&type=script&lang=ts&"
import style0 from "./IconCheckGray.vue?vue&type=style&index=0&id=5d4b07ab&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d4b07ab",
  null
  
)

export default component.exports